/**
 * Static list of 20 predefined suggestions for the first 3 suggestions shown on page load
 */
export const STATIC_SUGGESTIONS = [
  { label: 'What is a journey?', message: 'What is a customer journey in Customer.io?' },
  { label: 'How do I send emails?', message: 'How do I send my first email campaign?' },
  { label: 'What are segments?', message: 'What are customer segments and how do I create them?' },
  { label: 'How do I track events?', message: 'How do I track custom events in Customer.io?' },
  { label: 'What is A/B testing?', message: 'What is A/B testing and how do I set it up?' },
  { label: 'How do I use the API?', message: 'How do I integrate Customer.io with my application using the API?' },
  { label: 'What is Design Studio?', message: 'What is Design Studio and how do I use it?' },
  { label: 'How do I send SMS?', message: 'How do I send SMS campaigns to my customers?' },
  { label: 'What are webhooks?', message: 'What are webhooks and how do I configure them?' },
  { label: 'How do I add people?', message: 'How do I import and add customers to Customer.io?' },
  { label: 'What are attributes?', message: 'What are customer attributes and how do I manage them?' },
  { label: 'How do I test campaigns?', message: 'How do I test my campaigns before sending them?' },
  { label: 'What is personalization?', message: 'What is message personalization and how do I use it?' },
  { label: 'How do I schedule sends?', message: 'How do I schedule campaigns to send at specific times?' },
  { label: 'What are triggers?', message: 'What are campaign triggers and how do they work?' },
  { label: 'How do I handle unsubscribes?', message: 'How do I handle unsubscribe requests properly?' },
  { label: 'What are transactional emails?', message: 'What are transactional emails and how do I send them?' },
  { label: 'How do I measure success?', message: 'How do I measure and analyze campaign performance?' },
  { label: 'What integrations exist?', message: 'What third-party tools can I integrate with Customer.io?' },
  { label: 'How do I manage my team?', message: 'How do I add team members and manage permissions?' },
];

/**
 * Get 3 random static suggestions for initial page load
 */
export function getInitialStaticSuggestions() {
  const shuffled = [...STATIC_SUGGESTIONS].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, 3);
}
